export const reachGoal = (goal: string, maxRetries = 10, interval = 1000) => {
  const send = (retriesLeft: number) => {
    const ym = (
      window as unknown as {
        ym?: (id: number, event: string, name: string) => void;
      }
    ).ym;
    if (ym) {
      ym(24440456, 'reachGoal', goal);
    } else if (retriesLeft > 0) {
      console.log(
        `Метрика ym ещё не загружена. Попытка ${maxRetries - retriesLeft + 1} из ${maxRetries}. Событие "${goal}" не отправлено. Повтор через ${interval / 1000} секунд.`,
      );
      setTimeout(() => send(retriesLeft - 1), interval);
    } else {
      console.log(
        `Метрика ym не загружена после ${maxRetries} попыток. Событие "${goal}" не отправлено.`,
      );
    }
  };
  send(maxRetries);
};
